<template>
    <div class="bigBoss">
        <el-dialog
                title="详情"
                width="550px"
                :visible="detail.edit"
                :close-on-click-modal="false"
                @close="handleClose">
            <div class="title">
                <p>
                    <span>{{titleCount}}：</span>
                </p>
                <el-card class="box-card" shadow="hover">
                    <el-form :model="transactionHideEditForm" label-position="top" label-width="80px">
                        <el-form-item label="交易笔数">
                                <div>
                                    <el-form-item style="float: left;margin-right: 10px">
                                        <span class="line">交易满</span>
                                    </el-form-item>
                                    <el-form-item style="float: left">
                                        <el-input
                                                size="medium"
                                                style="width:100px"
                                                v-model="transactionHideEditForm.delay_sum"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item style="float: left;margin-left: 10px">
                                        <span class="line">笔</span>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                        <el-form-item label="激活天数">
                            <div>
                                <el-form-item style="float: left;margin-right: 10px">
                                    <span class="line">激活满</span>
                                </el-form-item>
                                <el-form-item style="float: left">
                                    <el-input
                                            size="medium"
                                            style="width:100px"
                                            v-model="transactionHideEditForm.delay_days"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item style="float: left;margin-left: 10px">
                                    <span class="line">天</span>
                                </el-form-item>
                            </div>
                        </el-form-item>
                        <el-form-item label="数据优化时间区间">
                            <template>
                                <el-time-picker
                                        is-range
                                        v-model="transactionHideEditForm.time"
                                        value-format="HH:mm:ss"
                                        range-separator="至"
                                        start-placeholder="开始时间"
                                        end-placeholder="结束时间"
                                        placeholder="选择时间范围">
                                </el-time-picker>
                            </template>
                        </el-form-item>
                        <el-form-item label="数据优化金额区间">
                            <div>
                                <el-form-item style="float: left">
                                    <el-input
                                            size="medium"
                                            style="width:100px"
                                            v-model="transactionHideEditForm.start_money"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item style="float: left;margin-left: 10px">
                                    <span class="line"> 元  至 </span>
                                </el-form-item>
                                <el-form-item style="float: left;margin-left: 10px">
                                    <el-input
                                            size="medium"
                                            style="width:100px"
                                            v-model="transactionHideEditForm.end_money"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item style="float: left;margin-left: 10px">
                                    <span class="line"> 元 </span>
                                </el-form-item>
                            </div>
                        </el-form-item>
                        <el-form-item label="优化方案">
                            <div>
                                <el-form-item style="float: left;margin-right: 10px">
                                    <span class="line"> 每 </span>
                                </el-form-item>
                                <el-form-item style="float: left">
                                    <el-input
                                            size="medium"
                                            style="width:100px"
                                            v-model="transactionHideEditForm.transaction_sum"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item style="float: left;margin-left: 10px">
                                    <span class="line"> 笔 优化 </span>
                                </el-form-item>
                                <el-form-item style="float: left;margin-left: 10px">
                                    <el-input
                                            size="medium"
                                            style="width:100px"
                                            v-model="transactionHideEditForm.transaction_handle"
                                            readonly
                                    ></el-input>
                                </el-form-item>
                                <el-form-item style="float: left;margin-left: 10px">
                                    <span class="line"> 笔 交易 </span>
                                </el-form-item>
                            </div>
                        </el-form-item>
                        <div style="margin-top:60px">
                            <el-button
                                @click="submit"
                                type="primary"
                                size="medium"
                                style="font-size:12px"
                                :loading="loading">
                                提 交
                            </el-button>
                        </div>
                    </el-form>
                </el-card>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "MAM_transactionHideEdit",
    props: {
        detail: {
            type: Object
        }
    },
    data() {
        return {
            stockInfoList: [],
            loading: false,
            transactionHideEditForm: {
                id:this.detail.info.id,
                delay_sum:this.detail.info.delay_sum, //交易笔数
                delay_days:this.detail.info.delay_days, //激活天数
                time:[this.detail.info.start_time,this.detail.info.end_time],  //非数据优化时间
                start_money:this.detail.info.start_money, //非数据优化最低金额
                end_money:this.detail.info.end_money, //非数据优化最高金额
                transaction_sum:this.detail.info.transaction_sum, //每xx笔优化xx笔交易
                transaction_handle:1, //每xx笔优化xx笔交易
            },
        };
    },
    mounted() {
    },
    methods: {
        handleClose(ref) { //关闭弹窗
            this.$emit('infoClose', ref);
        },
        submit()
        {
            this.$api.post('transaction/transactionHideEdit', this.transactionHideEditForm, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                    this.$emit('infoClose');
                } else {
                    this.$message.error(res.msg);
                }
            });
        }
    },
    computed: {
        titleCount() {
            let title;
            switch (this.detail.type) {
                case 5:
                    title = '编辑规则';
                    break;
            }
            return title;
        },
    }
};
</script>

<style scoped lang="scss">
.bigBoss {
  font-size: 12px;
  .el-input__inner,
  .tips {
    font-size: 12px;
  }

  .el-form-item {
    margin-bottom: 5px;
  }

  ::v-deep .el-form-item__label {
    padding: 0;
    font-size: 12px;
  }
  .titleTip {
    padding: 10px 10px;
    background-color: #ecf8ff;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 700;
    border-left: 5px solid #50bfff;
    margin: 10px 0;
  }
  .title p {
    font-size: 12px;
    :first-child {
      font-weight: 700;
    }
  }
}
</style>